

$(document).ready(function() {
  var totalSteps = $('.quiz-steps .step').length;
  var currentStep = 1;
  var progressWidth = 0;
  var selectedValues = [];
  var enteredName = "";
  var enteredNameList = "";
  var totalAge = 0;
  var averageAge = 0;
  var selected_saga = 1;
  var saga_value = 0;
  var nameOfChild;
  var sagaData = {
    1: {
      vid: 44099353116930,
      imgUrl: 'https://cdn.shopify.com/s/files/1/0564/9032/8257/files/BRAVE_Saga_1.webp?v=1705951963'
    },
    2: {
      vid: 44099353444610,
      imgUrl: 'https://cdn.shopify.com/s/files/1/0564/9032/8257/files/BRAVE_Saga_2.webp?v=1705951963'
    },
    3: {
      vid: 44099353772290,
      imgUrl: 'https://cdn.shopify.com/s/files/1/0564/9032/8257/files/BRAVE_Saga_3.webp?v=1705951963'
    },
    4: {
      vid: 44103507575042,
      imgUrl: 'https://cdn.shopify.com/s/files/1/0564/9032/8257/files/BRAVE_Saga_4_Bookstack.webp?v=1705959585'
    }
  }
  var GTMStepTracking = currentStep;

  // Reset the checkbox
    $('.terms-checkbox').prop('checked', false);
    
    // Reset the email field
    $('.email_field').val('');

  function debounce(func, delay) {
    let timeoutId;
    return function() {
        const context = this;
        const args = arguments;
        clearTimeout(timeoutId);
        timeoutId = setTimeout(() => {
            func.apply(context, args);
        }, delay);
    };
}

  // function to check if item exists on cart
  function checkVariantInCart(variantIdToCheck, onSuccess, onError) {
  $.ajax({
    type: 'GET',
    url: '/cart.js',
    dataType: 'json',
    success: function(cart) {
      var variantExistsInCart = false;
      for (var i = 0; i < cart.items.length; i++) {
        if (cart.items[i].variant_id == variantIdToCheck) {
          variantExistsInCart = true;
          break;
        }
      }

      return variantExistsInCart;
      
      if (variantExistsInCart) {
        if (onSuccess) {
          onSuccess(true); // Call the success callback with true if variant exists in cart
        }
      } else {
        if (onError) {
          onError(false); // Call the error callback with false if variant is not in cart
        }
      }
    },
    error: function(xhr, status, error) {
      // console.error(status + " " + error);
      if (onError) {
        onError(false); // Call the error callback with false if an error occurs
      }
    }
  });
}
  
  
  function handleHeaderForValues(no_of_children){
    var relation = Cookies.get("selected_relation");
    var nameofchilds = Cookies.get("name_age_list");    
    nameOfChild = JSON.parse(nameofchilds);
    enteredNameList = '';

    if (no_of_children > 3) {
      switch(relation) {
        case 'parentorgurdian':
          enteredNameList = 'your children?';
          break;
        case 'grandparent':
          enteredNameList = 'your grandchildren?';
          break;
        default:
          enteredNameList = 'your readers?';
      }
    } else if (no_of_children == 3) {
      enteredNameList = nameOfChild[0].name + ', ' + nameOfChild[1].name + ', and ' + nameOfChild[2].name + '?';
    } else if (no_of_children == 2) {
      enteredNameList = nameOfChild[0].name + ' and ' + nameOfChild[1].name + '?';
    } else {
      enteredNameList = nameOfChild[0].name + '?';
    }
    
    $('.child-names-collection').html(enteredNameList);  
  }
  
  updateProgressBar();

  function onNameChange(){
    $('.firstname_field').on('keyup', debounce(function() {
      enteredName = $(this).val().trim();
      $('.name-age-wrapper .school-title').text("What type of school is "+ enteredName +" enrolled in?");
    }, 250));
  }

  function nameAndAgeCondition(relation, no_of_children ){
    if(relation == "parentorgurdian"){
        if(no_of_children == 1){            
            $('.name-age-wrapper .name-ages-title').text("What is the name and age of your child?");
            onNameChange();            
        }else if(no_of_children > 10){
            $('.name-age-wrapper .name-ages-title').text("What are the names and ages of the 10 youngest children?");
            $('.name-age-wrapper .school-title').text("What type of school are your children enrolled in?");
        }else if(no_of_children >= 2){
            $('.name-age-wrapper .name-ages-title').text("What are their names and ages?");
            $('.name-age-wrapper .school-title').text("What type of school are your children enrolled in?");
        }
    }else if(relation == "grandparent"){
        if(no_of_children == 1){
            $('.name-age-wrapper .name-ages-title').text("What is the name and age of your grandchild?");
            onNameChange();
        }else if(no_of_children > 10){
            $('.name-age-wrapper .name-ages-title').text("What are the names and ages of the 10 youngest grandchildren?");
            $('.name-age-wrapper .school-title').text("What type of school are your children enrolled in?");
        }
        else if(no_of_children >= 2){
            $('.name-age-wrapper .name-ages-title').text("What are their names and ages?");
            $('.name-age-wrapper .school-title').text("What type of school are your grandchildren enrolled in?");
        }
    }else{
        if(no_of_children == 1){
            $('.name-age-wrapper .name-ages-title').text("What is the child's name and age?");
            onNameChange();
        }else if(no_of_children > 10){
            $('.name-age-wrapper .name-ages-title').text("What are the names and ages of the 10 youngest children?");
            $('.name-age-wrapper .school-title').text("What type of school are your children enrolled in?");
        }
        else if(no_of_children >= 2){
           $('.name-age-wrapper .name-ages-title').text("What are their names and ages?");
           $('.name-age-wrapper .school-title').text("What type of school are they enrolled in?");
        }
    }
  }

  // relation change text change
  
  function relationText(selectedRelation){    
    if(selectedRelation === "parentorgurdian"){
      $('.relation-child-heading').text('How many of your children are you browsing for?');
    } else if(selectedRelation === "grandparent"){
      $('.relation-child-heading').text('How many of your grandchildren are you browsing for?');
    } else {
      $('.relation-child-heading').text('How many children are you browsing for?');
    }
  }

  $('#relation').on('change', function (e) {
    var selectedRelation = $(this).val();
    relationText(selectedRelation);
  });
  
  // get name and age and set on array
  function getValueOfNameAndAge() {
    var dataArray = [];
    $('.name-age-container').each(function(index) {
        var firstName = $(this).find('.firstname_field').val();
        var age = $(this).find('.age_field').val();
        if(firstName == '' || age == ''){
          alert("Enter name and age.");
          return false;
        }
        dataArray.push({ "name": firstName, "age": age });
    });
    return dataArray;
}  

  // function to change checkbox value on step 1 
  function updateButtonState() {
    var terms_services_checked = $('input[name=agree]').is(':checked'); 
    var email_subscription_checked = $('input[name=subscribe]').is(':checked');
    
    if (terms_services_checked) {
        $('.step.step-1 .continue-btn').prop('disabled', false);
    } else {
        $('.step.step-1 .continue-btn').prop('disabled', true);
    }
    if (email_subscription_checked){
      localStorage.setItem("is_email_subscribed", email_subscription_checked);
      Cookies.set('is_email_subscribed', email_subscription_checked);      
    }
  }
  
  // change value of checkbox state on change for step 1
  $('input[name=agree], input[name=subscribe]').change(function() {
      updateButtonState(); // Update button state whenever a checkbox changes
  });

  $(document).on("keyup",".age_field",function() {
      // Get the entered value
    $('.value-checkbox input').prop('checked', false);
      var enteredValue = $(this).val();  
      if (enteredValue !== '' && parseInt(enteredValue) < 0) {
          alert('Please enter a non-negative number for age.');
          $(this).val('1');
      }
  });

  // function to handle step 2
  function handlestep2(number_of_children) {
    var relation = Cookies.get("selected_relation");
    var no_of_children = number_of_children;
    if(no_of_children > 10){
      var no_of_children_new = 10;
    }else{
      no_of_children_new = no_of_children;
    }
    var htmlContent = "";
    for (var i = 0; i < no_of_children_new; i++) {
        htmlContent += `<div class="name-age-container">
                            <input class="input_field firstname_field" type="text" name="first_name_${i+1}" placeholder="First name">
                            <input class="input_field age_field" type="number" name="age_${i+1}" placeholder="Age" min="0">
                        </div>`;
    }    
    $(".name-age-wrap").html(htmlContent);
    nameAndAgeCondition(relation, no_of_children);
  }

    // handle continue button on school selection

  function handleContBtnStep3(){
      // Check if any input field is empty
    var isAnyInputEmpty = $('.name-age-wrap input').filter(function() {
      return $(this).val().trim() === '';
    }).length > 0;
  
    // Check if no radio button is selected
    var isNoRadioButtonSelected = $('.checkbox-collection input[type="radio"]:checked').length === 0;
  
    if (isAnyInputEmpty || isNoRadioButtonSelected) {
      // return false;
      // Perform actions when an input field is empty or no radio button is selected
       // $('.quiz-footer .continue-btn').prop('disabled', true);
    } else {
      // Perform actions when all input fields are filled and a radio button is selected
       $('.quiz-footer .continue-btn').prop('disabled', false);
      // return true;
    } 
  }
  
  $('.checkbox-collection input[type="radio"]').on('change', function() {
    var elementType = $(this).is('input[type="radio"]') ? 'Radio button' : 'Input field';
    handleContBtnStep3();      
  });
  

  $(document).on("change",".name-age-container input",function() {
   // $('.name-age-container input').on('change', function() {
    // var elementType = $(this).is('input[type="radio"]') ? 'Radio button' : 'Input field';
     handleContBtnStep3();      
  });

  
  // $('.checkbox-collection input[type="checkbox"]
  $(document).on("change",'.checkbox-collection input[type="checkbox"]',function() {
     var anyCheckboxChecked = $('.checkbox-collection input[type="checkbox"]').is(':checked');
     $('.quiz-footer .continue-btn').prop('disabled', !anyCheckboxChecked);     
  });

  
  $('.input_field').on('input', function() {
    var fieldName = $(this).attr('name');
    var fieldValue = $(this).val();
    Cookies.set(fieldName, fieldValue);
  });

  function handleSagaAccordingToAge(name_age_list){
    var relation = Cookies.get("selected_relation");
    totalAge = 0;
    var numberOfPeople = 0;

    $.each(name_age_list, function(index, person) {
      if (parseInt(person.age) <= 12) {
        totalAge += parseInt(person.age);
        numberOfPeople++;
      }
    });
      
    averageAge = totalAge / numberOfPeople;
    if (averageAge <= 4){
      selected_saga = 1;
      
      $('.value-checkbox').hide();
      $('.value-checkbox.universal_values, .saga-1-value').show(); 
    } else if(averageAge == 5) {
      selected_saga = 2;
      
      $('.value-checkbox').hide();
      $('.value-checkbox.universal_values, .saga-2-value').show();
    } else if(averageAge == 6) {
      selected_saga = 3;
      
      $('.value-checkbox').hide();
      $('.value-checkbox.universal_values, .saga-3-value').show();
    } else {
      selected_saga = 4;
      
      $('.value-checkbox').hide();
      $('.value-checkbox.universal_values, .saga-4-value').show();
    }

    $('.quiz-saga-product-title h2').html(`Saga ${selected_saga}`);
    $('.saga-product-wrapper').removeClass('hidden');  
    var sagaValue = selected_saga - 1;
    $('.continue-btn').attr('data-sagaValue', sagaValue.toString());
    $('.continue-btn').attr('data-variantId', sagaData[selected_saga].vid);
    $('.quiz-saga-product-image img').attr('src', sagaData[selected_saga].imgUrl);
    $('.plan-select__image-container img').attr('src', sagaData[selected_saga].imgUrl);

    // for heading at recommending saga
    var no_of_child = name_age_list.length;
    if (no_of_child == 1){
      var name = name_age_list[0].name;
      $('.saga-recomendation-heading').html('<h2>Here\'s what we recommend for '+name+'');
    }
    else if (no_of_child >1){
      if (relation == 'parentorgurdian'){
        $('.saga-recomendation-heading').html('<h2>Here\'s what we recommend for your family!');
      }else if(relation == 'grandparent'){
        $('.saga-recomendation-heading').html('<h2>Here\'s what we recommend for your grandchildren!');
      }else if(relation == 'teacher'){
        $('.saga-recomendation-heading').html('<h2>Here\'s what we recommend for your class!');
      }else{
        $('.saga-recomendation-heading').html('<h2>Here\'s what we recommend for your readers!');
      }
    }
    if(no_of_child <= 3 ){
      let namesString = ""; 
      $.each(name_age_list, function(index, item) {
          namesString += item.name + ", ";
      });
      namesString = namesString.slice(0, -2);      
      var saga_description = $('.quiz-saga-description p');
      
      saga_description.html('Based on the information you provided, we\'ve curated the perfect plan for '+ namesString +'! This plan will start them out with picture books which align with the lessons and values you selected and will transition to chapter books when the picture book series ends after Saga 5.');
    }else{
      var saga_description = $('.quiz-saga-description p');
      if (relation == 'parentorgurdian'){
         saga_description.html(`Based on the information you provided, we've curated the perfect plan for you family! This plan will start them out with picture books that align with the lessons and values you selected. They will then transition to chapter books when the picture book series ends after Saga 5.`);
      }else if(relation != 'parentorgurdian' || relation != 'grandparent'){
        saga_description.html(`Based on the information you provided, we've curated the perfect plan for you readers! This plan will start them out with picture books that align with the lessons and values you selected. They will then transition to chapter books when the picture book series ends after Saga 5.`);
      }else if(relation == 'grandparent'){
        saga_description.html(`If they have more than 3 children and are the grandparent: Based on the information you provided, we've curated the perfect plan for your grandchildren! This plan will start them out with picture books that align with the lessons and values you selected. They will then transition to chapter books when the picture book series ends after Saga 5.`);
      }
    }      
  }

  function IsEmail(email) {
            const regex =
/^([a-zA-Z0-9_\.\-\+])+\@(([a-zA-Z0-9\-])+\.)+([a-zA-Z0-9]{2,4})+$/;
            if (!regex.test(email)) {
                return false;
            }
            else {
                return true;
            }
        }
  
  function handleSteps(dataStepValue){
    
    if (dataStepValue === 1) {
      var pattern = /^\b[A-Z0-9._%-]+@[A-Z0-9.-]+\.[A-Z]{2,4}\b$/i;
     var customer_email = $('.email_field').val();
      if(!IsEmail(customer_email))
      {
        alert('not a valid e-mail address');
        return false;
      }
      if (customer_email === '') {
        alert('input email to continue');
        return false;
      }
      Cookies.set("customer_email",customer_email);
      localStorage.setItem("customer_email", customer_email);
      return true;
    }
    
    if (dataStepValue === 2) {
      var selectedRelation = $('#relation').val();
      relationText(selectedRelation);
      var number_of_children = $('input[name="no_of_children"]').val();
      
      if (number_of_children.trim() == '') {
        alert("Please enter the number of children you're shopping for.");
        return false;
      } else if (number_of_children < 1) {
        alert("Please enter a number greater than 0");
        return false;
      } else if (selectedRelation.trim() !== '' && number_of_children.trim() !== '') {
        $('.continue-btn').prop('disabled', false);
        Cookies.set("selected_relation",selectedRelation);
        Cookies.set("number_of_children", number_of_children);
        handlestep2(number_of_children);        
      } else {
        // $('.quiz-footer .continue-btn').prop('disabled', true);
        alert("You must select the relation and number of children.");
        return false;
      }
      // $('.quiz-footer .continue-btn').prop('disabled', true);
      return true;
    }
    
    if(dataStepValue === 3){
      // $('.quiz-footer .continue-btn').prop('disabled', true);
      var name_age_list = getValueOfNameAndAge();
      var no_of_children = Cookies.get("number_of_children")
      var school_type = $('input[name="school-type"]:checked').val();
      if (school_type != undefined){
        var nameAgeList = JSON.stringify(name_age_list)
        Cookies.set("name_age_list", nameAgeList );
        Cookies.set("school_type", school_type);
      }else{
        alert("Select school type for children.");
        return false;
      }

      var isAnyInputEmpty = $('.name-age-wrap input').filter(function() {
        return $(this).val().trim() === '';
      }).length > 0;
      
      var isNoRadioButtonSelected = $('.checkbox-collection input[type="radio"]:checked').length === 0;    
      if (isAnyInputEmpty || isNoRadioButtonSelected) {
        return false;
      }
      
      handleHeaderForValues(no_of_children);      
      handleSagaAccordingToAge(name_age_list);
      
      return true;
    }
    
    if(dataStepValue === 4){
      $('.checkbox-collection input[type="checkbox"]:checked').each(function() {
        var value = $(this).val();
        if ($.inArray(value, selectedValues) === -1) {
          selectedValues.push(value); // Add unique value to the array
        }
        // selectedValues.push($(this).val());
      });      
      // Output the array of selected values
      // if(selectedValues.length == 0){
      //   alert("You must select at least one values.");
      //   return false;
      // }
      if ($('.value-checkbox input:checked').length === 0) {
        alert("Select at least one values.");
        return false;
            
      } 
      
      return true;
    }
    if(dataStepValue === 5){
      return true;
    }
    if(dataStepValue === 6){
      return true;
    }
    // if(dataStepValue === 7){
    //   var noneActive = true;
    //   $('.step-7 .select-gift').each(function() {
    //       if ($(this).hasClass('active')) {
    //           noneActive = false;
    //           return false;
    //       }
    //   });
      
    //   if (noneActive) {
    //     alert('Select the gift product to proceed.');
    //     return false;
    //   }
    //   return true;
    // }
    if(dataStepValue === 7){
      var noneActive = true;
      $('.step-8 .select-plan-btn').each(function() {
        if ($(this).hasClass('active')) {
          noneActive = false;
          return false;
        }
      });
      
      if (noneActive) {
        alert('Select the plan to proceed.');
        return false;
      }
      $('.done-choosing-btn').removeClass('hidden');
      $('.continue-btn').addClass('hidden');
      return true;
    }
    if(dataStepValue === 9){
      return true;
    }
  }

  $('.continue-btn').click(function() {
    $(window).scrollTop(0);
    
    var activeStepWrapper = $('.quiz-steps').find('.step-wrapper.active');
    var dataStepValue = activeStepWrapper.data('step');
    var isHandleStep = handleSteps(dataStepValue);
    if (!isHandleStep) {
      GTMStepTracking--;
    } else if (currentStep < totalSteps && isHandleStep) {
      currentStep++;
      updateProgressBar();
      updateButtonVisibility();
    }

    if (currentStep == 2) {
      if (screen.width > 500) {
        $('.quiz-footer .back-btn').css('display', 'block');
      }
      $('.quiz-header svg').css('display', 'block');
      $('.quiz-footer').css('display', 'flex');
      var email_subscription_checked = $('input[name=subscribe]').is(':checked');
      if (email_subscription_checked) {
        var settings = {
          "async": true,
          "crossDomain": true,
          "url": "https://manage.kmail-lists.com/ajax/subscriptions/subscribe",
          "method": "POST",
          "headers": {
            "content-type": "application/x-www-form-urlencoded",
            "cache-control": "no-cache"
          },
          "data": {
            "g": "W8uEFd",
            "email": $('.email_field').val(),
          }
        }
        $.ajax(settings).done(function (response) {
          console.log(response);
        });
      }
    } else if (currentStep == 5) {
      $('.quiz-footer').hide();
      setTimeout(function() {
        $('.quiz-footer').show();
            $('.quiz-footer .btn.continue-btn').click();
      }, 2000);
    } else if (currentStep == 7) {
      $('.quiz-footer').hide();
    } else {
      this.classList.remove('GTM-Step-' + GTMStepTracking);
      this.classList.add('GTM-Step-' + (GTMStepTracking + 1));
      GTMStepTracking++;
    }
  });

  // handle back button click
  $('.back-btn').click(function() {
    var continueBtn = $('.continue-btn')[1];
    
    currentStep--;
    updateButtonVisibility();
    updateProgressBar();
    if (currentStep == 1) {
      $('.quiz-footer').css('display', 'none');
      GTMStepTracking++;
    } else if (currentStep == 3) {
      handleContBtnStep3();
      continueBtn.classList.remove('GTM-Step-' + GTMStepTracking);
      continueBtn.classList.add('GTM-Step-' + (GTMStepTracking - 1));
    } else if (currentStep == 4) {
      $('.quiz-footer').show();
      continueBtn.classList.remove('GTM-Step-' + GTMStepTracking);
      continueBtn.classList.add('GTM-Step-' + (GTMStepTracking - 1));
    } else if (currentStep == 5) {
      $('.back-btn').click();
      GTMStepTracking++;
      $('.value-checkbox input').prop('checked', false);
    } else if (currentStep == 6) {
      GTMStepTracking++;
      $('.quiz-footer').show();
    } else {
      continueBtn.classList.remove('GTM-Step-' + GTMStepTracking);
      continueBtn.classList.add('GTM-Step-' + (GTMStepTracking - 1));
    }
    GTMStepTracking--;
    
    $('.quiz-footer .continue-btn').prop('disabled', false);
  });

  // function to update progress bar
  function updateProgressBar() {
    var totalBarWidth = $('.progress-container').width();
    var lengthToIncrement = totalBarWidth / (totalSteps - 1);
    progressWidth = lengthToIncrement * (currentStep - 1);
    $('.progress-bar').css('width', progressWidth + 'px');
    $('.quiz-steps .step').addClass('hidden');
    $('.quiz-steps .step').removeClass('active');
    $('.quiz-steps .step-'+ currentStep).removeClass('hidden');
    $('.quiz-steps .step-'+ currentStep).addClass('active');
  }

  // handle button visibility 
  function updateButtonVisibility() {
    if (currentStep === 1) {
      $('.quiz-footer .back-btn').addClass('hidden');
    }else if (currentStep == totalSteps){
      $('.quiz-footer .btn.continue-btn').addClass('hidden');
    } 
    else {
      $('.quiz-footer .btn.back-btn').removeClass('hidden');
      $('.quiz-footer .btn.continue-btn').removeClass('hidden');
    }
  }



  // function to handle add to cart functionality
  function addVariantToCart(variantId, sellingPlanId, ele) {
    // ClearCart();

    $('.step-8 .select-plan-btn').each(function() {
      $(this).html("Select plan");
      $(this).removeClass("active");
    });
    ele.addClass("active");
    ele.html("Plan Selected");
    
    $('.quiz-footer .continue-btn').prop('disabled', false);
    $('.quiz-footer .btn.continue-btn').click();
    return true;

    let payload = {
     'items': [{
      'id': variantId,
      'selling_plan': sellingPlanId,
      'quantity': 1
      }]
    };

    fetch("/cart/add.js", {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
      },
      body: JSON.stringify(payload),
    })
      .then((response) => response.json())
      .then(() => {
        // Redirect to the checkout page
        setTimeout(function() { 
          $('.step-8 .select-plan-btn').each(function() {
              $(this).html("Select plan");
              $(this).removeClass("active");
          });
          ele.addClass("active");
          ele.html("Plan Selected");
          $('.quiz-footer .continue-btn').prop('disabled', false);
        }, 2000);
        
      });
  }

  function ClearCart(){
    $.ajax({
        type: "POST",
        url: '/cart/clear.js',
        data: '',
        dataType: 'json',
        success: function(data) {
          return;
        }
      });
  }

  // handle plan selection button click
  $(document).on("click",".select-plan-btn",function() {
    var ele = $(this);
    var sellingPlanId = ele.attr('data-sellingplanid');
    var variantId = ele.attr('data-variantId');
    
    //find which saga is selected
    // also find if it is monthly or annual plan selected
    addVariantToCart(variantId, sellingPlanId, ele);
  });

  $(document).on("click",".step-7 .select-gift.unselected",function() {
    console.log(this);
    var ele = $(this);
    var variantId = ele.attr('data-variantid');
    $('.step-7 .select-gift').removeClass("active");
    $('.step-7 .select-gift').addClass("unselected");
    $('.step-7 .select-gift').html("Select gift");
    ele.addClass('active');
    ele.removeClass('unselected');
    ele.html("Gift selected");
    return true;
  });

  $(document).on("click",".step-7 .select-gift.active",function() {
    var ele = $(this);
    var variantId = ele.attr('data-variantid');
    ele.html("Removing...");
    $.ajax({
    type: 'POST',
    url: '/cart/update.js',
    dataType: 'json',
    data: { updates: { [variantId]: 0 } }, // Ensure the data is formatted correctly
    success: function(response) {         
        // setTimeout(function() { 
      ele.removeClass('active');
      ele.addClass('unselected');
      $('.step-7 .select-gift').each(function() {
        $(this).prop('disabled', false);
        ele.html("Select gift");
      });
        // }, 2000);
    }, 
      error: function(error){
        ele.html("Select Gift");
      }
    });     
  });

  $(document).on("click",".step-6 .select-gift.unselected",function() {
    var ele = $(this);
    saga_value = parseInt(ele.attr("data-sagaValue"));
    ele.html("Adding...");
    setTimeout(function() { 
      $('.step-6 .select-gift.unselected').each(function() {
        $(this).removeClass("active");
        $(this).html("Select");
      });
      ele.addClass('active');
      ele.html("Selected");

      $('.step-6 .select-saga-btn').each(function() {
        $(this).removeClass("saga-selected");
        $(this).text("Select Saga");
      });
      
    }, 2000);
    return true;
    
    var variantId = ele.attr('data-variantid');    
    let payload = {
     'items': [{
      'id': variantId,
      'quantity': 1
      }]
    };
    
    fetch("/cart/add.js", {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
      },
      body: JSON.stringify(payload),
    })
      .then((response) => response.json())
      .then(() => {
        // Redirect to the checkout page
        ele.html("Adding...");
        setTimeout(function() { 
          ele.addClass('active');
          ele.html("selected");
        }, 2000);
        
      })
      .catch((error) => {
        console.log("Error adding variant to cart:", error);
        // Handle errors here
      });
  });
  
// for modal
   $(".see-more-text").on('click', function() {
        $(".custom-model-main").addClass('model-open');
      });
      $(".close-btn, .bg-overlay").click(function(){
        $(".custom-model-main").removeClass('model-open');
      });

  
  $(document).on("click",".step-9 .claim-free-gift-btn",function() {
    var ele = $(this);  
    ele.text("Selecting...");
     $('.done-choosing-btn').click();
     setTimeout(function() {
       if(ele.hasClass("Selected")){
          ele.removeClass("Selected");
          ele.text("Claim Free Gift");
        }else{
          ele.addClass("Selected");
          ele.text("Gift Selected");
        }
       
     }, 1000);
    
  });

  $(document).on("click",".step-6 .select-saga-btn",function() {
    var ele = $(this);
    var selected = false;
    $('.step-6 .select-saga-btn').each(function() {
      if ($(this).hasClass("saga-selected")) selected = true;
      $(this).removeClass("saga-selected");
      $(this).removeClass("primary-button");
      $(this).addClass("secondary-button");
      $(this).text("Select");
    });

    if ( !selected ) {
      ele.addClass("saga-selected");
      $(this).addClass("primary-button");
      $(this).removeClass("secondary-button");
      ele.text("adding...");
      setTimeout(() => {
        ele.text("Selected");
        $('.quiz-footer .btn.continue-btn').click();
      }, 1000);
    }
  });

  // handle plan selection button click
  $(document).on("click",".add-products-btn",function() {
    ClearCart();
    var ele = $(this);
    var selectedSaga = parseInt(saga_value);
    var planType = $('.step-8 .select-plan-btn.active').attr("data-plan");
    if(planType == "monthly"){
      var plan_selected_product = 43306058449154;
      var selected_plan = 3039756546;
    }else{
      var plan_selected_product = 43367563428098;
      var selected_plan = 3039789314;
    }
    var gift_Selected = $(".step-7 .select-gift.active").attr("data-variantid");
    var bonus_gift1_variant =$('.bonus-gift-1').attr("data-variantid");
    var bonus_gift2_variant =$('.bonus-gift-2').attr("data-variantid");
    var bonus_saga = ele.attr("data-variantid1");
    var bonus_saga_treasure_box = ele.attr("data-variantid2");
    let updates = {
      bonus_gift1_variant: 1,
      bonus_gift2_variant: 1
    };
    ele.text("Adding...");

    setTimeout(function() { 
      let payload = {
        'items': [
          {
            'id': plan_selected_product,
            'selling_plan': selected_plan,
            'quantity': 1
          },
          {
            'id': gift_Selected,
            'quantity': 1
          },
          {
            'id': bonus_saga,
            'quantity': 1
          },
          {
            'id': bonus_saga_treasure_box,
            'quantity': 1
          }
        ]
      };
      
      // Check if claim-free-gift-btn has the class 'Selected'
      if (document.querySelector('.claim-free-gift-btn').classList.contains('Selected')) {
          // Add bonus gifts if the button is selected
          payload.items.push(
            {
              'id': bonus_gift1_variant,
              'quantity': 1
            },
            {
              'id': bonus_gift2_variant,
              'quantity': 1
            }
          );
      }
  
      fetch("/cart/add.js", {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify(payload),
      })
        .then((response) => response.json())
        .then((response) => {
          ele.text("Added");
          window.location.href = "/checkout";
          if(response.status == "422"){
            alert(response.message);
            window.location.href = "/checkout";
          }else{
              window.location.href = "/checkout";           
          }
          
        })
        .catch((error) => {
          console.log("Error adding variant to cart:", error);
        });
    }, 2000);
  });

  var variantIds = {
    monthly:[
      44099353116930,
      44099353444610,
      44099353772290,
      44103507575042
    ],
    annual: [
      44099387818242,
      44099388145922,
      44099388473602,
      44103595852034
    ]
  }
  
  $(document).on("click",".select-payment-plan",function() {
    ClearCart();
    var ele = $(this);
    ele.text("Adding...");

    // Get selected saga
    var sagaSelectButton = $('.select-saga-btn.saga-selected').attr("data-sagavalue");
    if (sagaSelectButton) {
      saga_value = sagaSelectButton;
    } else {
      saga_value = $(".continue-btn").attr("data-sagavalue");
    }

    // Get variant id based on plan type
    var planType = ele.attr("data-plan");
    var sellingPlanId;
    planType == 'monthly' ? sellingPlanId = 3010134274 : sellingPlanId = 3010167042;
    var chosenVariantId = variantIds[planType][saga_value];
    
    // var gift_Selected = $(".step-7 .select-gift.active").attr("data-variantid");

      let payload = {
        'items': [
          {
            'id': chosenVariantId,
            'selling_plan': sellingPlanId,
            'quantity': 1,
            'properties': {
              _curated_flow_order: 'true'
            }
          },
          {
            'id': 43921553490178,
            'quantity': 1
          }
        ]
      };
  
      fetch("/cart/add.js", {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify(payload),
      })
        .then((response) => response.json())
        .then((response) => {
          ele.text("Added");
          
          // Reset the checkbox
          $('.terms-checkbox').prop('checked', false);
          // Reset the email field
          $('#email_field').val('');

          if (response.status == "422") {
            alert(response.message);
            window.location.href = "/checkout";
          } else {
            window.location.href = "/checkout";         
          }
        })
        .catch((error) => {
          console.log("Error adding variant to cart:", error);
        });
  });
});

